import firebase from "firebase";
import {auth, db, storage} from "../../main";
import router from "../../router";

const state = {
  user: {
    loggedIn: false,
    data: null
  }
}

const getters = {
  user: state => {
    return state.user
  }
}

const mutations = {
  setLoggedIn: (state, value) => {
    state.user.loggedIn = value
  },
  setUser: (state, data) => {
    state.user.data = data
  }
}

const actions = {
  signUp: ({state, dispatch}, payload) => {
    methods.showModal('loading-modal')

    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(data => {
        data.user.updateProfile({
          displayName: payload.name
        })
          .then(() => {
            const date = new Date();
            const toDoListCreationTime = date.getTime()

            db.collection('users')
              .doc(data.user.uid)
              .set({
                email: payload.email,
                id: data.user.uid,
                name: payload.name,
                profilePictureUrl: null,
                inboxToDoListId: null,
                personalToDoListOwned: [],
                tokenId: []
              })
              .then(() => {
                if (payload.profilePictureFile !== null) {
                  // create a storage ref
                  let storageRef = storage.ref('profileImages').child(data.user.uid + '.jpg')
                  // upload file
                  storageRef.put(payload.profilePictureFile)
                    .then(snapshot => {
                      // update the database
                      snapshot.ref.getDownloadURL().then(downloadUrl => {
                        db.collection('users')
                          .doc(data.user.uid)
                          .update({
                            profilePictureUrl: downloadUrl
                          })

                        // change the actual user profile picture
                        let user = auth.currentUser
                        user.updateProfile({
                          photoURL: downloadUrl
                        })
                      })
                    })
                }
              })

            db.collection('inbox_to_do_lists')
              .add({
                ownerId: data.user.uid,
                ownerName: payload.name,
                toDoListCreationDate: firebase.firestore.FieldValue.serverTimestamp(),
                toDoListCreationTime: toDoListCreationTime,
                toDoListId: null,
                toDoListName: 'Inbox'
              })
              .then(docRef => {
                const inboxToDoListId = docRef.id
                db.collection('inbox_to_do_lists')
                  .doc(inboxToDoListId)
                  .update('toDoListId', inboxToDoListId)

                db.collection('users')
                  .doc(data.user.uid)
                  .update('inboxToDoListId', inboxToDoListId)

              })
              .then(docRef => {
                methods.hideModal('loading-modal')

                dispatch('logOut')
              })
          })
      })
      .catch(err => {
        let error = err.message
        console.error(error)
        alert('The email address is already in use by another account.')
        methods.hideModal('loading-modal')
      });
  },
  signIn: ({state}, payload) => {
    methods.showModal('loading-modal')

    firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(data => {
        methods.hideModal('loading-modal')

        router.replace({name: "Home"})
        state.homeSelectedComponent = 'listCategoryHome'
      })
      .catch(err => {
        methods.hideModal('loading-modal')

        let error = err.message
        console.error(error)
        alert('Invalid username and/or password.')
      });
  },
  logOut: () => {
    console.log("user logout")

    firebase
      .auth()
      .signOut()
      .then(() => {
        router.replace({name: "Sign In"})
      })
  },
  fetchUser: ({commit}, user) => {
    commit("setLoggedIn", user !== null);

    if (user) {
      commit("setUser", {
        id: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL
      });
      console.log('user logged in:', user)
    } else {
      commit("setUser", null);
      console.log('No user logged in')
    }
  }
}

const methods = {
  showModal(id) {
    router.app.$root.$emit('bv::show::modal', id)
  },
  hideModal(id) {
    router.app.$root.$emit('bv::hide::modal', id)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
